import App from './app/App';
import CallWeb from './app/CallWeb';

if (TMON.oDealMain) {
  TMON.oDealMain.oCallWeb = new CallWeb();
  TMON.oApp = new App();
  TMON.oApp.init();
}
